import Types from './types';

const userStorage = JSON.parse(localStorage.getItem('info_user') || '[]');

const initState = {
	spinnerRoute: true,
	user: userStorage,
	authenticated: false,
	session: {
		loading: false,
		data: null,
		error: null
	}
};

const authReducer = (state = initState, action) => {
	switch (action.type) {
		case Types.AUTH_SET_SESSION: {
			return {
				...state,
				authenticated: true,
				user: action.payload
			};
		}

		case Types.SPINNER_ROUTE: {
			return { ...state, spinnerRoute: !state.spinnerRoute };
		}

		case Types.AUTHENTICATED: {
			return { ...state, authenticated: action.payload };
		}

		case Types.LOGOUT: {
			window.location.reload();
			return {};
		}

		default:
			return state;
	}
};

export default authReducer;
